import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "report-view" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = {
  key: 0,
  class: "title"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "d-row user-status"
}

import ReportTable from "@/components/tables/ReportTable.vue";
import OvertimeOverview from "@/components/OvertimeOverview.vue";
import MonthlyHistory from "@/components/MonthlyHistory.vue";
import TileCard from "@/components/util/TileCard.vue";
import { onBeforeMount, onUnmounted, reactive } from "vue";
import { useReportingMonthStore } from "@/stores/reporting";
import { Authorization } from "@/services/authenticate";
import { MonthlyApprovalItem, ApprovalStatus } from "@/services/entities/Approval/MonthlyApprovalItem"
import { useApprovalStore } from "@/stores/approval"
import { useOvertimeStore } from "@/stores/overtime"
import { showToastError } from "@/toastification";
import { useUserStore } from "@/stores/user";
import { useAdminLockStore } from "@/stores/adminLock";
import { isDateBeforeOther } from "@/common/date";
import MonthSelector from "@/components/util/MonthSelector.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ReportHoursView',
  setup(__props) {

const reportingStore = useReportingMonthStore();
const approvalStore = useApprovalStore();
const overtimeStore = useOvertimeStore();
const userStore = useUserStore();
const adminLockStore = useAdminLockStore();

const state = reactive({
  date: { year: (new Date).getFullYear(), month: (new Date).getMonth() },
  dailyCommitment: 0,
  saving: false,
});

onBeforeMount(async () => {
  setDailyCommitment();
  await reportingStore.loadReportingMonth(state.date.year, state.date.month + 1, Authorization.id);
  await overtimeStore.loadOvertimeModel(state.date.year, state.date.month + 1, Authorization.id);
  await adminLockStore.loadAdminLock(state.date.year, state.date.month + 1, Authorization.id);  
});

onUnmounted(() => {
  reportingStore.clearReportingMonth();
});

function setDailyCommitment(){
  state.dailyCommitment = userStore.getLoggedUser.dailyCommitments
                            .filter(a => isDateBeforeOther(a, state.date))
                            .sort((a, b) => b.month - a.month).sort((a, b) => b.year - a.year)[0]?.hours ?? 0;
}

async function loadMonth() {
  setDailyCommitment(); 
  await reportingStore.loadReportingMonth(
    state.date.year,
    state.date.month + 1,
    Authorization.id
  );
  await overtimeStore.loadOvertimeModel(state.date.year, state.date.month + 1, Authorization.id);
  await adminLockStore.loadAdminLock(state.date.year, state.date.month + 1, Authorization.id);
}


function onMonthSelected(newDate: any) {
  state.date = newDate;
  loadMonth();
}


async function save() {
  state.saving = true;
  try
  {
    // Check if there are any lines without ActivityNumberId
    if (reportingStore.getAll.lines.some(a => (a.projectTypeId == 0 || a.projectTypeId == 1) && !a.activity)) {
      showToastError("Please select activity for all projects");
      return;
    }
    // Group by project and activity, then count the number of lines, if more than 1, show error
    let grouped = reportingStore.getAll.lines.reduce((a, b) => {
      let key = `${b.project?.projectId}-${b.activity?.id}-${b.customActivity}`;
      if (!a[key]) {
        a[key] = 0;
      }
      a[key]++;
      return a;
    }, {} as { [key: string]: number });
    let errors = Object.keys(grouped).filter(a => grouped[a] > 1);
    if (errors.length > 0) {
      showToastError("There are multiple lines for the same project and activity");
      return;
    }
    reportingStore.getAll.lines.forEach(a => {
      a.projectId = a.project?.projectId;
      if (a.activity) {
        a.activityNumberId = a.activity?.id;
      }
      if (a.projectTypeId > 90 || a.projectTypeId == 2) {
        a.activityTypeId = 0;
        a.activityNumberId = reportingStore.getAll.projects.find(b => b.projectId == a.projectId)?.activityNumbers[0]?.id ?? "";
      }
    });
    
    reportingStore.getAll.lines.forEach((a) => {
        a.days.forEach((b) => {
          if (typeof b.hours == "string") {
            b.hours = null;
          }
        });
      });

    reportingStore.getAll.actionAuthor = Authorization.id;
    reportingStore.getAll.lines = reportingStore.getAll.lines.filter(a => a.project);
    await reportingStore.saveMonth(reportingStore.getAll);
    await reportingStore.loadReportingMonth(state.date.year, state.date.month + 1, Authorization.id);
    await overtimeStore.loadOvertimeModel(state.date.year, state.date.month + 1, Authorization.id);
    await adminLockStore.loadAdminLock(state.date.year, state.date.month + 1, Authorization.id);  
  } finally {
    state.saving = false;
  }
}

function checkApproved() {
  return (
    (reportingStore.getAll.approvalStatus.id as ApprovalStatus) ==
    ApprovalStatus.Approved
  );
}


async function sendForApproval() {
  let mA = {} as MonthlyApprovalItem;
  mA.year = state.date.year;
  mA.month = state.date.month + 1;
  mA.userId = Authorization.id;
  mA.status = ApprovalStatus.SentForApproval

  await approvalStore.saveApproval(mA, Authorization.id);
  await reportingStore.loadReportingMonth(state.date.year, state.date.month + 1, Authorization.id);
  await overtimeStore.loadOvertimeModel(state.date.year, state.date.month + 1, Authorization.id);
}

function isAdminLocked(): boolean {
  return adminLockStore.getAll?.isLocked ?? false;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(Authorization).accountName) + "'s reporting", 1),
      (isAdminLocked())
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, " - Locked by admin"))
        : _createCommentVNode("", true),
      _createVNode(MonthSelector, { onMonthSelected: onMonthSelected })
    ]),
    _createVNode(TileCard, {
      id: "report-table",
      loaded: !_unref(reportingStore).getAllLoaded
    }, {
      body: _withCtx(() => [
        (_unref(reportingStore).getAll.projects.length > 0)
          ? (_openBlock(), _createBlock(ReportTable, {
              key: 0,
              reportingMonth: _unref(reportingStore).getAll,
              "daily-commitment": state.dailyCommitment,
              readonly: isAdminLocked() || state.saving,
              saving: state.saving
            }, {
              buttons: _withCtx(() => [
                (!checkApproved())
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: sendForApproval,
                      disabled: state.saving
                    }, "Send for approval", 8, _hoisted_5))
                  : _createCommentVNode("", true),
                (!checkApproved())
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "accent",
                      onClick: save,
                      disabled: state.saving
                    }, "Save", 8, _hoisted_6))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["reportingMonth", "daily-commitment", "readonly", "saving"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, "No projects assigned"))
      ]),
      _: 1
    }, 8, ["loaded"]),
    (!_unref(reportingStore).getAllLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(OvertimeOverview, {
            overtimeModel: _unref(overtimeStore).getModel,
            loaded: _unref(overtimeStore).getModelLoaded
          }, null, 8, ["overtimeModel", "loaded"]),
          _createVNode(MonthlyHistory, {
            year: state.date.year,
            month: state.date.month,
            userId: _unref(reportingStore).getAll.userId
          }, null, 8, ["year", "month", "userId"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})